export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9184.56388b6d.jpg";